import { readBlobAsBase64 } from './readBlobAsBase64';

export const convertFileToBase64 = async (file: File): Promise<string> => {
  if (!file) {
    throw new Error('convertFileToBase64: file is required');
  }

  const dataUrl = await readBlobAsBase64({ blob: file, errorPrefix: 'convertFileToBase64' });

  return dataUrl;
};
